import { PaletteMode } from "@mui/material";
import Color from "./colors" ;

const ThemeOption = (mode:PaletteMode) => {

    const defaultPaper = '#ffffff';
    // const contrastText = '#ffffff';

    return (mode ==="light" ? {
        primary:{
            200:Color.primary[200] ,
            main:Color.primary.lightMain ,
            800:Color.primary[800] ,
            background : {
                default:defaultPaper ,
                paper:Color.primary.lightContainer
            } ,
        } ,
        secondary:{
            200:Color.secondary[200] ,
            main:Color.secondary.lightMain ,
            800:Color.secondary[800] ,
            background : {
                default:defaultPaper ,
                paper:Color.secondary.lightContainer
            },
        } ,
        tertiary: {
            200:Color.tertiary[200] ,
            main:Color.tertiary.lightMain ,
            800:Color.tertiary[800] ,
            background : {
                default:defaultPaper ,
                paper:Color.tertiary.lightContainer
            },
        } ,

        error :{
            main :Color.error.lightMain
        }
    } : {
        primary:{
            200:Color.primary[200] ,
            main:Color.primary.darkMain ,
            800:Color.primary[800] ,
            background : {
                default:defaultPaper ,
                paper:Color.primary.darkContainer
            },
        } ,
        secondary:{
            200:Color.secondary[200] ,
            main:Color.secondary.darkMain ,
            800:Color.secondary[800] ,
            background : {
                default:defaultPaper ,
                paper:Color.secondary.darkContainer
            },
        } ,
        tertiary: {
            200:Color.tertiary[200] ,
            main:Color.tertiary.darkMain ,
            800:Color.tertiary[800] ,
            background : {
                default:defaultPaper ,
                paper:Color.tertiary.darkContainer
            },
        } ,
        error :{
            main :Color.error.darkMain
        }
    });
}

export default ThemeOption;